
const languages = {
    AR : {
        search: "بحث",
        placeholder: "دعني اساعدك في الاختيار",
        signOut: "تسجيل خروج",
        home: "الرئيسية",
        GPTSearch: "بحث ذكي",
        moviesCategoryName: ["جارية الآن" , "الأعلى تقييما", "قريبا" , "رائج"],
        gptQuery: "Act as a Movie Recommendation system and suggest some movies for the query : . only give me names of 5 movies, comma seperated like the example result given ahead. Example Result: Gadar, Sholay, Don, Golmaal, Koi Mil Gaya",

    },
    EN : {
        search: "Search",
        placeholder: "What Do You Want To Watch?",
        signOut: "Sign Out",
        home: "Home",
        GPTSearch:"GPT Search",
        moviesCategoryName: ["Now Playing" , "Top Rated", "Upcomming" , "Popular"],
        gptQuery: "Act as a Movie Recommendation system and suggest some movies for the query : . only give me names of 5 movies, comma seperated like the example result given ahead. Example Result: Gadar, Sholay, Don, Golmaal, Koi Mil Gaya",
    
       
    },
    spanish: {
        search: "buscar",
        placeholder: "¿Qué te gustaría ver hoy?",
        signOut: "Que Out",
        home: "Homo",
        GPTSearch: "GPT سSearch",
        moviesCategoryName: ["Now Pplaying" , "Top Rated", "Upcomming" , "Popular"],

      },
}

export default languages;